import { render, staticRenderFns } from "./Sys_formfld.vue?vue&type=template&id=5085d508&scoped=true"
import script from "./Sys_formfld.vue?vue&type=script&lang=js"
export * from "./Sys_formfld.vue?vue&type=script&lang=js"
import style0 from "./Sys_formfld.vue?vue&type=style&index=0&id=5085d508&prod&scoped=true&lang=less"
import style1 from "./Sys_formfld.vue?vue&type=style&index=1&id=5085d508&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5085d508",
  null
  
)

export default component.exports